import { productSlug } from "@/lib/product";
import { getProjects as cmsGetProjects, getProjectBySlug as cmsGetProjectBySlug } from "@/lib/cms";

// Mirrors admin SEO Settings → "Enable Projects module".
// Build-time only — the frontend is a static export, so toggling requires a redeploy.
export const isProjectsEnabled = () =>
  (process.env.NEXT_PUBLIC_PROJECTS_ENABLED ?? "true").toLowerCase() !== "false";

const ensureSlug = (p) => ({
  ...p,
  slug: p.slug || productSlug(p.title),
});

// Slim list of all CMS-fetched projects. Returns an empty array when the
// admin is unreachable — the frontend renders its empty state instead.
export const getAllProjects = async () => {
  const { data } = await cmsGetProjects({ perPage: 100 });
  return data.map(ensureSlug);
};

export const getProjectBySlug = async (slug) => {
  const fromCms = await cmsGetProjectBySlug(slug);
  if (fromCms) return ensureSlug(fromCms);
  return null;
};

export const getRelatedProjects = async (limit = 4) => {
  const list = await getAllProjects();
  return list.slice(0, limit);
};
